<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap">
      <section class="boss-contractperiod-container">
        <div class="boss-contractperiod-wrap">
          <div class="boss-posting-container">
            <div class="boss-posting-wrap boss-main-content-wrap">
              <form>
                <div class="boss-layout boss-layout-vertical">
                  <div>
                    <Accordion :is-open="true">
                      <template #head>
                        よく使う項目
                      </template>
                      <template #body>
                        <div class="boss-table-2">
                          <scout-form-company-id v-model="companyId" />
                          <scout-form-age v-model="searchData.parameter.age" />
                          <scout-form-gender v-model="searchData.parameter.gender" />
                          <scout-form-prefecture
                            v-model="searchData.parameter.address.prefectures"
                            :selected-option.sync="searchData.parameter.address.selectedOption"
                            :contain-work-prefectures-non-hope-user.sync="searchData.parameter.address.containNonHopeUser"
                          />
                          <scout-form-educational-background
                            v-model="searchData.parameter.educationalBackground"
                            :from.sync="searchData.parameter.graduatedSchool.year.from"
                            :to.sync="searchData.parameter.graduatedSchool.year.to"
                            :free-word.sync="searchData.condition.graduatedSchoolKeyword"
                            :operator.sync="searchData.parameter.graduatedSchool.operator"
                          />
                          <scout-form-changed-jobs v-model="searchData.parameter.changeOverJobsCount.maximum" />
                          <scout-form-employed v-model="searchData.parameter.employed" />
                          <scout-form-annual-salary
                            v-bind.sync="searchData.parameter.annualSalary"
                            prefix="直近の"
                          />
                          <scout-form-annual-salary
                            v-bind.sync="searchData.parameter.desiredSalary"
                            prefix="希望の"
                          />
                          <scout-form-occupation
                            :experienced-occupations.sync="searchData.parameter.occupations.experienced"
                            :desired-occupations.sync="searchData.parameter.occupations.desired"
                            :selected-option.sync="searchData.parameter.occupations.operator"
                            :contain-occupations-non-hope-user.sync="searchData.parameter.occupations.containNonHopeUser"
                          />
                          <scout-form-sector
                            :experienced-businesses.sync="searchData.parameter.businesses.experienced"
                            :desired-businesses.sync="searchData.parameter.businesses.desired"
                            :selected-option.sync="searchData.parameter.businesses.operator"
                            :contain-businesses-non-hope-user.sync="searchData.parameter.businesses.containNonHopeUser"
                          />
                          <scout-form-skill
                            v-model="searchData.parameter.skills.conditions"
                            :selected-option.sync="searchData.parameter.skills.operator"
                          />
                          <scout-form-license
                            v-model="searchData.parameter.licenses.ids"
                            :selected-option.sync="searchData.parameter.licenses.operator"
                          />
                          <dummy-scout-form-behavior />
                          <scout-form-active-recent v-model.number="searchData.parameter.activeRecent" />
                          <scout-form-others :has-career-resumes.sync="searchData.parameter.hasCareerResumes" />
                        </div>
                      </template>
                    </Accordion>
                  </div>
                  <!-- さらに詳しい条件設定 -->
                  <div>
                    <Accordion :is-open="false">
                      <template #head>
                        さらに詳しい条件設定
                      </template>
                      <template #body>
                        <div class="boss-table-2">
                          <scout-form-language-skill
                            :toeic.sync="searchData.parameter.toeicScore.minimum"
                            :toefl.sync="searchData.parameter.toeflScore.minimum"
                            :english.sync="searchData.parameter.englishSkill.minimum"
                          />
                          <scout-form-change-jobs-motivation v-model="searchData.parameter.changeJobsMotivations" />
                          <scout-form-company-style v-model="searchData.parameter.companyStyle" />
                          <scout-form-free-word
                            v-model="searchData.condition.freeWord"
                            :exclude-word.sync="searchData.condition.excludeWord"
                            :operator.sync="searchData.parameter.freeWord.operator"
                          />
                          <scout-form-other-company-scouts v-model.number="searchData.parameter.excludedApproachedScout.otherCompany.maximum" />
                          <scout-form-search-behavior
                            :occupation.sync="searchData.parameter.searchingOccupations"
                            :prefecture.sync="searchData.parameter.searchingWorkPrefectures"
                            :sector.sync="searchData.parameter.searchingBusinesses"
                          />
                          <scout-form-registration-date
                            :from.sync="searchData.condition.registrationDate_from"
                            :to.sync="searchData.condition.registrationDate_to"
                            :selected-option.sync="searchData.condition.selectedRegistrationDateValue"
                          />
                          <scout-form-resume-update-date
                            :from.sync="searchData.condition.resumeUpdateDate_from"
                            :to.sync="searchData.condition.resumeUpdateDate_to"
                            :selected-option.sync="searchData.condition.selectedResumeUpdateDateValue"
                          />
                          <scout-form-active-date v-bind.sync="searchData.parameter.activeDate" />
                          <dummy-scout-form-exclude
                            :applies-other-company.sync="searchData.parameter.excludeEntryOtherCompanyJob"
                            :applies-casual-interview-entry-other-company.sync="searchData.parameter.excludeCasualInterviewEntryOtherCompanyJob"
                          />
                          <scout-form-member-id
                            v-model="searchData.parameter.userId"
                            explanation="会員IDを入力した場合は他の検索条件は無効となります。"
                          />
                        </div>
                      </template>
                    </Accordion>
                  </div>
                  <!-- さらに詳しい条件設定 -->
                </div>
                <dummy-search-trigger-container
                  :search-count="searchCount"
                  :is-searching="isSearching"
                  :is-error="isError"
                />
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { SearchDataModel } from '@/model/searchDataModel'
import Accordion from '@/components/atoms/Accordion'
import ScoutFormActiveDate from '@/components/atoms/ScoutFormActiveDate'
import ScoutFormActiveRecent from '@/components/atoms/ScoutFormActiveRecent'
import ScoutFormAge from '@/components/atoms/ScoutFormAge'
import ScoutFormAnnualSalary from '@/components/atoms/ScoutFormAnnualSalary'
import ScoutFormChangedJobs from '@/components/atoms/ScoutFormChangedJobs'
import ScoutFormChangeJobsMotivation from '@/components/atoms/ScoutFormChangeJobsMotivation'
import ScoutFormCompanyStyle from '@/components/atoms/ScoutFormCompanyStyle'
import ScoutFormEducationalBackground from '@/components/atoms/ScoutFormEducationalBackground'
import ScoutFormEmployed from '@/components/atoms/ScoutFormEmployed'
import ScoutFormFreeWord from '@/components/atoms/ScoutFormFreeWord'
import ScoutFormGender from '@/components/atoms/ScoutFormGender'
import ScoutFormLanguageSkill from '@/components/atoms/ScoutFormLanguageSkill'
import ScoutFormLicense from '@/components/atoms/ScoutFormLicense'
import ScoutFormMemberId from '@/components/atoms/ScoutFormMemberId'
import ScoutFormOccupation from '@/components/atoms/ScoutFormOccupation'
import ScoutFormOtherCompanyScouts from '@/components/atoms/ScoutFormOtherCompanyScouts'
import ScoutFormOthers from '@/components/atoms/ScoutFormOthers'
import ScoutFormPrefecture from '@/components/atoms/ScoutFormPrefecture'
import ScoutFormResumeUpdateDate from '@/components/atoms/ScoutFormResumeUpdateDate'
import ScoutFormRegistrationDate from '@/components/atoms/ScoutFormRegistrationDate'
import ScoutFormSearchBehavior from '@/components/atoms/ScoutFormSearchBehavior'
import ScoutFormSector from '@/components/atoms/ScoutFormSector'
import ScoutFormSkill from '@/components/atoms/ScoutFormSkill'
import ScoutFormCompanyId from '@/components/atoms/ScoutFormCompanyId'
// ダミー用
import DummyScoutFormBehavior from '@/components/atoms/DummyScoutFormBehavior'
import DummyScoutFormExclude from '@/components/atoms/DummyScoutFormExclude'
import DummySearchTriggerContainer from '@/components/molecules/DummySearchTriggerContainer'

export default {
  components: {
    Accordion,
    ScoutFormActiveDate,
    ScoutFormActiveRecent,
    ScoutFormAge,
    ScoutFormAnnualSalary,
    ScoutFormChangedJobs,
    ScoutFormChangeJobsMotivation,
    ScoutFormCompanyStyle,
    ScoutFormEducationalBackground,
    ScoutFormEmployed,
    ScoutFormFreeWord,
    ScoutFormGender,
    ScoutFormLanguageSkill,
    ScoutFormLicense,
    ScoutFormMemberId,
    ScoutFormOccupation,
    ScoutFormOtherCompanyScouts,
    ScoutFormOthers,
    ScoutFormPrefecture,
    ScoutFormRegistrationDate,
    ScoutFormResumeUpdateDate,
    ScoutFormSearchBehavior,
    ScoutFormSector,
    ScoutFormSkill,
    ScoutFormCompanyId,
    DummySearchTriggerContainer,
    DummyScoutFormBehavior,
    DummyScoutFormExclude
  },
  data () {
    return {
      searchCount: 0,
      searchData: new SearchDataModel(),
      companyId: null,
      isSearching: false,
      isError: true
    }
  },
  watch: {
    searchData: {
      handler () {
        this.debouncedFetchMembersCount()
      },
      deep: true
    },
    'searchData.condition.graduatedSchoolKeyword' (val) {
      this.setKeywordsFromConditionToParameter(val, 'graduatedSchool')
    },
    'searchData.condition.freeWord' (val) {
      this.setKeywordsFromConditionToParameter(val, 'freeWord')
    },
    'searchData.condition.excludeWord' (val) {
      this.setKeywordsFromConditionToParameter(val, 'excludeWord')
    },
    // 最終ログインのバインド
    'searchData.condition.selectedRegistrationDateValue' (val) {
      this.$set(this.searchData.parameter.registrationDate, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.registrationDate, 'selectedDateTimeRangeForm', null)
      }
    },
    // NOTE: selectedDateTimeRangeForm内のプロパティは、optionId: ''の時にnullにしてほしいバックエンドの要望があるため、直接バインドできない
    'searchData.condition.registrationDate_from' (val) {
      if (this.searchData.condition.selectedRegistrationDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'registrationDate.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.registrationDate_to' (val) {
      if (this.searchData.condition.selectedRegistrationDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'registrationDate.selectedDateTimeRangeForm.to', val)
      }
    },
    // レジュメ更新日のバインド
    'searchData.condition.selectedResumeUpdateDateValue' (val) {
      this.$set(this.searchData.parameter.resumeUpdateDate, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.resumeUpdateDate, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.resumeUpdateDate_from' (val) {
      if (this.searchData.condition.selectedResumeUpdateDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.resumeUpdateDate_to' (val) {
      if (this.searchData.condition.selectedResumeUpdateDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedApproachedThisJobOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.approachedThisJob_from' (val) {
      if (this.searchData.condition.selectedApproachedThisJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.approachedThisJob_to' (val) {
      if (this.searchData.condition.selectedApproachedThisJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedApproachedOtherJobOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.approachedOtherJob_from' (val) {
      if (this.searchData.condition.selectedApproachedOtherJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.approachedOtherJob_to' (val) {
      if (this.searchData.condition.selectedApproachedOtherJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedLikedOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedLiked, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedLiked, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.liked_from' (val) {
      if (this.searchData.condition.selectedLikedOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.liked_to' (val) {
      if (this.searchData.condition.selectedLikedOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.to', val)
      }
    },
    // ダミーBOSSでのwatch
    companyId: {
      handler () {
        this.debouncedFetchMembersCount()
      }
    }
  },
  created () {
    this.debouncedFetchMembersCount = _.debounce(this.fetchMembersCount, 500)
    if (!this.searchData.parameter.age.minimum) {
      this.searchData.parameter.age.minimum = 18
    }
    if (!this.searchData.parameter.age.maximum) {
      this.searchData.parameter.age.maximum = 65
    }
  },
  methods: {
    fetchMembersCount () {
      const apiParameter = this.createAPIParameter()
      this.$set(this, 'isSearching', true)
      this.$http.secured.post('operation/scout/_search/_count', apiParameter).then(response => {
        if (_.isEqual(JSON.parse(response.config.data), this.createAPIParameter())) {
          this.$set(this, 'isError', false)
          this.$set(this, 'searchCount', response.data)
          this.$set(this, 'isSearching', false)
        }
      }).catch((error) => {
        // 現在の検索条件とAPIで投げた検索条件が一致している場合
        if (_.isEqual(JSON.parse(error.response.config.data), this.createAPIParameter())) {
          this.$set(this, 'isError', true)
          this.$set(this, 'isSearching', false)
        }
      })
    },
    createAPIParameter () {
      const storeParameter = _.cloneDeep(this.searchData.parameter)
      const apiParameter = { companyId: this.companyId, ...storeParameter }
      if (apiParameter.skills && apiParameter.skills.conditions) {
        apiParameter.skills.conditions = apiParameter.skills.conditions.filter(condition => condition.years.minimum !== '')
      }
      if (apiParameter.occupations.desired) {
        apiParameter.occupations.desired = apiParameter.occupations.desired.map(x => x.id)
      }
      if (apiParameter.occupations.experienced) {
        apiParameter.occupations.experienced = apiParameter.occupations.experienced.filter(x => x.years.minimum !== '')
      }
      return apiParameter
    },
    setKeywordsFromConditionToParameter (val, path) {
      const keywords = val.trim()
      if (keywords) {
        this.$set(this.searchData.parameter[path], 'keywords', (keywords.split(/\s+/g)))
      } else {
        this.$set(this.searchData.parameter[path], 'keywords', ([]))
      }
    },
    getWithinDaysFromTerms (val) {
      // selectedDateTime系の日数を取得する
      const terms = _.get(val, 'terms', '')
      if (terms === '' || terms === 'select') {
        // 初期値 / 未指定 / 日時指定の場合は、日数はnullで返却
        return null
      } else {
        return terms
      }
    }
  }
}
</script>
